import React from "react";
import { withStyles } from "@material-ui/core";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";

export const MaterialStepper = withStyles({
  root: {
    padding: "0",
  }
})(Stepper);

export const MaterialStep = withStyles({
  root: {
    "& .MuiStepLabel-iconContainer svg" : {
      width: "40px",
      height: "40px"
    },
    "& .MuiStepIcon-active" : {
      color: "#277661"
    },
    "& .MuiStepIcon-completed" : {
      color: "rgba(39, 118, 97, 0.5)"
    },
    "& .MuiStepLabel-label" : {
      fontSize: "14px"
    }
  }
})(Step);


